<template>
  <keep-alive>
    <v-layout column>
      <v-flex>
        <h1>
          Search People
          <v-btn small color="primary" @click="newPersonDialog = true">
            <v-icon>add</v-icon> Create Person
          </v-btn>
        </h1>
      </v-flex>

      <v-flex>
        <v-form @submit.prevent="searchForPeople">
          <v-text-field
            :error="status == 'error'"
            :error-messages="message"
            prepend-icon="search"
            placeholder="Search Pharmacists (ID, HPI, FirstName and/or Surname)"
            v-model="searchString"
            :autofocus="true"
          ></v-text-field>
        </v-form>
      </v-flex>
      <v-layout justify-space-between>
        <v-flex sm5>
          <lookup-select
            chips
            multiple
            lookup-name="PractisingStatus"
            label="Practising Status"
            v-model="searchFilters.practicingStatusId"
            clearable
          />
        </v-flex>
        <!-- <v-flex sm4>
          <lookup-select
            disabled
            chips
            multiple
            lookup-name="ScopesOfPractice"
            label="Scope of Practice"
            v-model="search.filters.scopeofpractice"
          />
        </v-flex> -->
      </v-layout>

      <v-data-table
        dense
        :items="results"
        :loading="status === 'loading'"
        :headers="tableHeaders"
        :options.sync="options"
        single-expand
        :expanded.sync="expanded"
      >
        <template v-slot:item="props">
          <!-- <tr @click="$router.push('/people/'+props.item.id)"> -->
          <tr
            @click="
              expanded[0] === props.item
                ? (expanded = [])
                : (expanded = [props.item])
            "
            @dblclick="$router.push('/people/' + props.item.id)"
          >
            <td>#{{ props.item.id }}</td>
            <td>{{ props.item.title }}</td>
            <td>{{ props.item.nickname }}</td>
            <td>{{ props.item.firstname }}</td>
            <td>{{ props.item.middlenames }}</td>
            <td>{{ props.item.surname }}</td>
            <!-- <td>{{props.item.genderid==1 ? "female" : "male"}}</td>
            <td>{{props.item.birthdate | formatDate}}</td> -->
            <td
              v-if="
                props.item.practitioner &&
                  props.item.practitioner.practicingstatus
              "
            >
              {{ props.item.practitioner.practicingstatus.name }}
            </td>
            <td v-else></td>
            <td>
              {{
                $store.getters.lookup(
                  "ReferralTypes",
                  props.item.referralid || false
                ) || ""
              }}
            </td>
          </tr>
        </template>

        <template v-slot:expanded-item="props">
          <tr @dblclick="$router.push('/people/' + props.item.id)">
            <td :colspan="tableHeaders.length">
              <personSummary :personId="props.item.id" :key="props.item.id" />
            </td>
          </tr>
        </template>
      </v-data-table>
      <!-- </v-flex> -->
      <v-dialog
        v-model="newPersonDialog"
        scrollable
        :overlay="false"
        max-width="80vw"
        transition="dialog-transition"
      >
        <pharmacistDetail personId="new" />
        <!-- <v-btn icon @click="newPersonDialog = false"
          ><v-icon>close</v-icon></v-btn
        > -->
      </v-dialog>
    </v-layout>
  </keep-alive>
</template>

<script>
import debounce from "lodash/debounce";
import personSummary from "@/components/people/summary.vue";
import pharmacistDetail from "@/components/pharmacists/detail.vue";
export default {
  name: "searchPeople",
  data() {
    return {
      newPersonDialog: false,
      status: "",
      message: [],
      tableHeaders: [
        { text: "Reg #", value: "id" },
        { text: "title", value: "title" },
        { text: "Preferred Name", value: "nickname" },
        { text: "First Name", value: "firstname" },
        { text: "Middle Names", value: "middlenames" },
        { text: "Surname", value: "surname" },
        // { text: "Gender", value: "genderid" },
        // { text: "BirthDate", value: "birthdate" },
        {
          text: "Practising Status",
          value: "practitioner.practicingstatusid"
        },
        { text: "Referred For", value: "referralid" }
      ]
    };
  },
  watch: {
    "$route.query.s": {
      handler(to, from) {
        if (this.searchString !== to) {
          this.searchString = to;
        }
      },
      immediate: true
    },
    searchString() {
      debounce(this.searchForPeople, 1000);
    }
  },
  computed: {
    results() {
      return this.$store.getters.searchResults.filter(this.customFilter);
    },

    searchFilters: {
      get() {
        return this.$store.getters.getSearchFilters;
      },
      set(val) {
        this.$store.commit("setSearchFilters", val);
      }
    },
    expanded: {
      get() {
        return this.$store.getters.getSearchExpanded;
      },
      set(val) {
        this.$store.commit("setSearchExpanded", val);
      }
    },
    options: {
      get() {
        return this.$store.getters.getSearchOptions;
      },
      set(val) {
        this.$store.commit("setSearchOptions", val);
      }
    },
    searchString: {
      get() {
        return this.$store.getters.getSearchString;
      },
      set(to, from) {
        this.$store.commit("setSearchString", to);
      }
    }
  },
  methods: {
    searchForPeople: async function(init) {
      if (!this.searchString || this.status === "loading") {
        return;
      }
      this.status = "loading";
      console.debug("searching for people");

      var whereFilter = this.searchString
        .split(" ")
        .filter(t => t)
        .map(substr => {
          return {
            or: [
              { id: { like: `${substr}%` } },
              { hpi: { like: `${substr}%` } }, //only if the hpi starts with it
              { nickname: { like: `%${substr}%` } },
              { firstname: { like: `%${substr}%` } },
              { surname: { like: `%${substr}%` } },
              { contactemailaddress: { like: `%${substr}%` } }
            ]
          };
        });

      try {
        const result = await this.$store.dispatch("search", {
          filter: {
            where: {
              and: whereFilter
            },
            include: ["practitioner"]
            // limit: 10
          }
        });
        if (result) {
          console.log("got saved results: ", result);

          this.status = "success";
        } else {
          throw new Error("No results from server");
        }
      } catch (e) {
        this.status = "error";
        this.message.push(e.message);
        console.error(e);
      }
    },
    customFilter(person) {
      if (!this.searchFilters?.practicingStatusId?.length) {
        console.debug("no customfilter found");
        return true;
      }
      try {
        console.debug("running CustomFilter", person, this.searchFilters);

        if (
          this.searchFilters?.practicingStatusId?.includes(
            person?.practitioner?.practicingstatusid
          )
        ) {
          console.debug("including in results");
          return true;
        } else {
          return false;
        }
      } catch (e) {
        console.error("error in customfilter execution", e);
        return false;
      }
    },
    setRouteString(string) {
      if (this.$route.query.s !== string) {
        this.$router.replace({ query: { s: string } });
      }
    }
  },
  components: {
    personSummary,
    pharmacistDetail
  },
  beforeMount() {
    let urlSearch = this.$route.query.s;
    let prevSearch = this.$store.state.people.search.string;
    if (urlSearch) {
      this.searchString = urlSearch;
    } else if (prevSearch) {
      this.setRouteString(prevSearch);
    }
  },
  created() {
    this.searchForPeople();
  }
};
</script>
